import { Linkable } from '@/components/blocks/Linkable';
import { MyWishlistProductCard } from '@/components/content/Header/parts/MyWishlist/ProductCard';
import { panelStyles } from '@/components/content/Header/styles/myWishList';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { useLocalization } from '@/data/Localization';
import { ProductType } from '@/data/types/Product';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { MATERIAL_SYMBOL_ICONS } from 'shared/custom/constants/commonConstants';

export const MyWishlistList: FC<{
	recentItems: {
		partNumber: string;
		description: string;
		listId: string;
	}[];
	products: (ProductType | null)[];
	purchasedProducts: string[];
}> = ({ recentItems, products, purchasedProducts }) => {
	const routes = useLocalization('Routes');
	const wishlistPanelLabels = useLocalization('MyWishlistPanel');

	return (
		<>
			<Box display="flex" flexDirection="column" alignItems="center">
				{recentItems?.map(
					(
						item: {
							partNumber: string;
							description: string;
							listId: string;
						},
						index: number
					) => {
						const list = { name: item.description, id: item.listId };
						const product =
							products?.find(
								(product: ProductType | null) => product?.partNumber === item.partNumber
							) ?? ({} as ProductType);
						const isLast = index === recentItems.length - 1;
						const isPurchasedProduct = purchasedProducts.some(
							(pp: string) => pp === item.partNumber
						);

						return (
							<>
								<MyWishlistProductCard
									partNumber={item.partNumber}
									list={list}
									product={product}
									isPurchasedProduct={isPurchasedProduct}
								/>
								{!isLast ? <Divider sx={panelStyles.divider} /> : null}
							</>
						);
					}
				)}
			</Box>
			<Divider />
			<Stack sx={panelStyles.itemContainer}>
				<Linkable
					href={{
						pathname: routes.WishLists.route.t(),
						query: { action: 'create-list' },
					}}
					sx={panelStyles.itemLink}
					id="createNewList"
				>
					<Box display="flex" alignItems="center">
						<DynamicIcon name={MATERIAL_SYMBOL_ICONS.add} sx={panelStyles.linkColor} />
						<Typography variant="bodyBaseline" sx={panelStyles.itemText}>
							{wishlistPanelLabels.CreateNewList.t()}
						</Typography>
					</Box>
				</Linkable>
			</Stack>
			<Stack sx={panelStyles.itemContainer}>
				<Linkable href={routes.WishLists.route.t()} sx={panelStyles.itemLink} id="allLists">
					<Box display="flex" alignItems="center">
						<DynamicIcon name={MATERIAL_SYMBOL_ICONS.favorite} sx={panelStyles.linkColor} />
						<Typography variant="bodyBaseline" sx={panelStyles.itemText}>
							{wishlistPanelLabels.SeeAllMyLists.t()}
						</Typography>
					</Box>
				</Linkable>
			</Stack>
		</>
	);
};
